module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.92f84d8b.eot";